import React, { useMemo } from 'react'
import { Navigate } from 'react-router-dom'
import { useUserStatus } from 'hooks/useUserStatus'
import { getPathFromPageId } from 'helpers/getPathFromPageId'
import { useSelector } from 'react-redux'
import {
  selectTestEnvironmentQueryParam,
  selectUUID,
} from 'root-redux/selects/user'
import { selectCurrentVariantCohort } from 'root-redux/selects/common'

interface IProps {
  isAvailable: boolean
  children: React.ReactElement
}

export const ProtectedRoute: React.FC<IProps> = ({ isAvailable, children }) => {
  const availableRoute = useUserStatus()
  const uuid = useSelector(selectUUID)
  const cohort = useSelector(selectCurrentVariantCohort)
  const testEnvironmentQueryParam = useSelector(selectTestEnvironmentQueryParam)

  const pathToRedirect = useMemo(
    () =>
      getPathFromPageId({
        pageId: availableRoute,
        cohort,
        uuid,
        testEnvironmentQueryParam,
      }),
    [availableRoute, cohort, uuid, testEnvironmentQueryParam],
  )

  return isAvailable ? children : <Navigate to={`/${pathToRedirect}`} />
}
